import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { CRM_TOKEN_STORAGE_KEY, customerSearch, customerServiceAdd, customerServiceLog, qiWeiPasswordLogin as qiWeiPasswordLoginApi } from '@/api';
import { Form, Input, Button, Space, Alert, message } from 'ant-design-vue';
let ExternalUser = class ExternalUser extends Vue {
    constructor() {
        super(...arguments);
        this.tokens = '';
        this.searchLoading = false;
        this.hasSearched = false;
        this.selectedCustomerIndex = -1;
        this.customerList = [];
        this.serviceLogLoading = false;
        this.serviceLogList = [];
        this.addServiceLoading = false;
        this.newServiceRemark = '';
        this.crmLogin = {
            username: '',
            password: '',
            qw_user_id: '',
        };
        this.searchForm = {
            mobile: '',
            keyword: ''
        };
    }
    get showSearchEmpty() {
        return this.hasSearched && this.customerList.length === 0;
    }
    get selectedCustomer() {
        if (this.selectedCustomerIndex < 0)
            return null;
        return this.customerList[this.selectedCustomerIndex] || null;
    }
    async qiWeiPasswordLogin() {
        const res = await qiWeiPasswordLoginApi(this.crmLogin);
        console.log(res);
        if (res.code == 0) {
            const token = (res.data && res.data.token) ? res.data.token : res.data;
            this.tokens = token || '';
            if (this.tokens) {
                window.localStorage.setItem(CRM_TOKEN_STORAGE_KEY, this.tokens);
            }
            message.success('绑定成功');
        }
        else {
            message.error(res.message);
        }
    }
    async handleSearch() {
        const mobile = (this.searchForm.mobile || '').trim();
        const keyword = (this.searchForm.keyword || '').trim();
        if (!mobile && !keyword) {
            message.warning('手机号和姓名至少填写一个');
            return;
        }
        this.searchLoading = true;
        try {
            const res = await customerSearch({
                mobile,
                keyword
            });
            this.hasSearched = true;
            if (res && res.code === 0) {
                const list = res?.data?.data;
                this.customerList = Array.isArray(list) ? list : [];
                this.selectedCustomerIndex = this.customerList.length > 0 ? 0 : -1;
                if (this.selectedCustomerIndex > -1) {
                    await this.fetchServiceLog(this.customerList[this.selectedCustomerIndex]);
                }
                else {
                    this.serviceLogList = [];
                }
            }
            else if (res && res.code === 401000) {
                this.handleTokenExpired();
            }
            else {
                this.customerList = [];
                this.selectedCustomerIndex = -1;
                this.serviceLogList = [];
                message.error((res && res.message) || '搜索失败');
            }
        }
        catch (e) {
            if (e?.response?.data?.code === 401000) {
                this.handleTokenExpired();
                return;
            }
            this.customerList = [];
            this.selectedCustomerIndex = -1;
            this.serviceLogList = [];
            message.error(e?.message || '搜索失败');
        }
        finally {
            this.searchLoading = false;
        }
    }
    async selectCustomer(index) {
        this.selectedCustomerIndex = index;
        const customer = this.customerList[index];
        await this.fetchServiceLog(customer);
    }
    getCustomerSource(customer) {
        return customer.source_tag_label || customer.source_name || customer.source || customer.source_tag || customer.source_product || '-';
    }
    async addServiceLog() {
        if (!this.selectedCustomer)
            return;
        const remark = (this.newServiceRemark || '').trim();
        if (!remark) {
            message.warning('请先输入回访内容');
            return;
        }
        const customerId = this.selectedCustomer.customer_id || this.selectedCustomer.id;
        if (!customerId) {
            message.warning('当前客户缺少 customer_id');
            return;
        }
        this.addServiceLoading = true;
        try {
            const res = await customerServiceAdd({
                customer_id: customerId,
                remark,
                service_type: ''
            });
            if (res && res.code === 0) {
                this.newServiceRemark = '';
                message.success('新增回访记录成功');
                await this.fetchServiceLog(this.selectedCustomer);
            }
            else if (res && res.code === 401000) {
                this.handleTokenExpired();
            }
            else {
                message.error((res && res.message) || '新增回访记录失败');
            }
        }
        catch (e) {
            if (e?.response?.data?.code === 401000) {
                this.handleTokenExpired();
                return;
            }
            message.error(e?.message || '新增回访记录失败');
        }
        finally {
            this.addServiceLoading = false;
        }
    }
    async fetchServiceLog(customer) {
        if (!customer) {
            this.serviceLogList = [];
            return;
        }
        const customerId = customer.customer_id || customer.id;
        if (!customerId) {
            this.serviceLogList = [];
            return;
        }
        this.serviceLogLoading = true;
        try {
            const res = await customerServiceLog({
                customer_id: customerId
            });
            if (res && res.code === 0) {
                const list = this.parseServiceLogList(res);
                this.serviceLogList = Array.isArray(list) ? list : [];
            }
            else if (res && res.code === 401000) {
                this.handleTokenExpired();
            }
            else {
                this.serviceLogList = [];
            }
        }
        catch (e) {
            if (e?.response?.data?.code === 401000) {
                this.handleTokenExpired();
                return;
            }
            this.serviceLogList = [];
        }
        finally {
            this.serviceLogLoading = false;
        }
    }
    parseServiceLogList(res) {
        if (Array.isArray(res?.data))
            return res.data;
        if (Array.isArray(res?.data?.data))
            return res.data.data;
        if (Array.isArray(res?.data?.list))
            return res.data.list;
        if (Array.isArray(res?.list))
            return res.list;
        return [];
    }
    getServiceLogTime(log) {
        return log.created_at || log.create_time || log.service_time || log.visit_time || '-';
    }
    getServiceLogContent(log) {
        return log.content || log.remark || log.desc || log.record || '-';
    }
    getServiceLogAdmin(log) {
        return log.admin_name || log.admin || log.user_name || '-';
    }
    handleTokenExpired() {
        window.localStorage.removeItem(CRM_TOKEN_STORAGE_KEY);
        this.tokens = '';
        this.hasSearched = false;
        this.customerList = [];
        this.selectedCustomerIndex = -1;
        this.serviceLogList = [];
        message.warning('登录已失效，请重新登录');
    }
    async mounted() {
        this.tokens = window.localStorage.getItem(CRM_TOKEN_STORAGE_KEY) || '';
    }
};
ExternalUser = __decorate([
    Component({
        name: 'ExternalUser',
        components: {
            'a-alert': Alert,
            'a-space': Space,
            'a-form': Form,
            'a-input': Input,
            'a-textarea': Input.TextArea,
            'a-button': Button,
        }
    })
], ExternalUser);
export default ExternalUser;
